import css from 'styled-jsx/css';
import { colors, typography } from '../../../../config/styles';
import { svgToDataUri } from '../../../../utils/styles/svgMixins';

const shoeIcon =
  '<?xml version="1.0" encoding="UTF-8"?><svg width="17px" height="27px" viewBox="0 0 17 27" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <title>icon/sizeguide/shoes</title> <desc>Created with Sketch.</desc> <g id="CASOS-BUY-SECTION---1280px-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="PDP-Availability-Initial-variations-selectsize" transform="translate(-840.000000, -298.000000)"> <g id="PROD" transform="translate(80.000000, 26.000000)"> <g id="Group-5" transform="translate(592.000000, 272.000000)"> <g id="Guia-de-tallas" transform="translate(168.000000, 0.000000)"> <g id="icon/sizeguide/shoes"> <g id="Talla-zapatos-calzado_Mesa-de-trabajo-1"> <g id="Group" transform="translate(12.725898, 1.196203)" stroke="#8FCA00" stroke-width="0.8424"> <polyline id="Shape" points="0.141398866 0.0341772152 3.53497164 0.0341772152 3.53497164 24.693038 0.141398866 24.693038"></polyline> <line x1="3.39357278" y1="3.34936709" x2="2.05028355" y2="3.34936709" id="Shape" stroke-linecap="square"></line> <line x1="3.39357278" y1="6.86962025" x2="2.05028355" y2="6.86962025" id="Shape" stroke-linecap="square"></line> <line x1="3.39357278" y1="10.3898734" x2="2.05028355" y2="10.3898734" id="Shape" stroke-linecap="square"></line> <line x1="3.39357278" y1="13.9101266" x2="2.05028355" y2="13.9101266" id="Shape" stroke-linecap="square"></line> <line x1="3.39357278" y1="17.4303797" x2="2.05028355" y2="17.4303797" id="Shape" stroke-linecap="square"></line> <line x1="3.39357278" y1="20.9506329" x2="2.05028355" y2="20.9506329" id="Shape" stroke-linecap="square"></line> </g> <g id="Group-12" fill="#070308" fill-rule="nonzero"> <path d="M1.78418054,4.7164557 C1.78418054,4.7164557 1.80185539,4.7164557 1.80185539,4.7164557 C4.0819121,4.51139241 3.88748866,0.119620253 1.76650568,0 C1.66045653,0 1.57208224,0 1.48370795,0 C-0.884723056,0.222151899 -0.142379011,4.87025316 1.78418054,4.7164557 Z M1.53673252,0.42721519 C1.60743195,0.427215189 1.67813138,0.427215189 1.74883081,0.427215189 C2.19603616,0.427215189 2.64324151,0.529113924 2.98277201,0.835443038 C3.32230251,1.14177215 3.55415816,1.65126582 3.55415816,2.16075949 C3.55415816,2.67025316 3.32230251,3.17974684 2.98277201,3.48607595 C2.64324151,3.79240506 2.19603616,3.89430379 1.74883081,3.89430379 C1.30162546,3.89430379 0.854420112,3.79240506 0.514889609,3.48607595 C0.175359106,3.17974684 -0.0564965468,2.67025316 -0.0564965468,2.16075949 C-0.0564965468,1.65126582 0.175359106,1.14177215 0.514889609,0.835443038 C0.854420112,0.529113924 1.30162546,0.427215189 1.74883081,0.427215189 Z" id="Shape"></path> </g> </g> </g> </g> </g> </g> </g></svg>';

const shoeIconRebranded =
  '<?xml version="1.0" encoding="UTF-8"?><svg width="17px" height="27px" viewBox="0 0 17 27" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <title>icon/sizeguide/shoes</title> <desc>Created with Sketch.</desc> <g id="CASOS-BUY-SECTION---1280px-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="PDP-Availability-Initial-variations-selectsize" transform="translate(-840.000000, -298.000000)"> <g id="PROD" transform="translate(80.000000, 26.000000)"> <g id="Group-5" transform="translate(592.000000, 272.000000)"> <g id="Guia-de-tallas" transform="translate(168.000000, 0.000000)"> <g id="icon/sizeguide/shoes"> <g id="Talla-zapatos-calzado_Mesa-de-trabajo-1"> <g id="Group" transform="translate(12.725898, 1.196203)" stroke="#495867" stroke-width="0.8424"> <polyline id="Shape" points="0.141398866 0.0341772152 3.53497164 0.0341772152 3.53497164 24.693038 0.141398866 24.693038"></polyline> <line x1="3.39357278" y1="3.34936709" x2="2.05028355" y2="3.34936709" id="Shape" stroke-linecap="square"></line> <line x1="3.39357278" y1="6.86962025" x2="2.05028355" y2="6.86962025" id="Shape" stroke-linecap="square"></line> <line x1="3.39357278" y1="10.3898734" x2="2.05028355" y2="10.3898734" id="Shape" stroke-linecap="square"></line> <line x1="3.39357278" y1="13.9101266" x2="2.05028355" y2="13.9101266" id="Shape" stroke-linecap="square"></line> <line x1="3.39357278" y1="17.4303797" x2="2.05028355" y2="17.4303797" id="Shape" stroke-linecap="square"></line> <line x1="3.39357278" y1="20.9506329" x2="2.05028355" y2="20.9506329" id="Shape" stroke-linecap="square"></line> </g> <g id="Group-12" fill="#070308" fill-rule="nonzero"> <path d="M1.78418054,4.7164557 C1.78418054,4.7164557 1.80185539,4.7164557 1.80185539,4.7164557 C4.0819121,4.51139241 3.88748866,0.119620253 1.76650568,0 C1.66045653,0 1.57208224,0 1.48370795,0 C-0.884723056,0.222151899 -0.142379011,4.87025316 1.78418054,4.7164557 Z M1.53673252,0.42721519 C1.60743195,0.427215189 1.67813138,0.427215189 1.74883081,0.427215189 C2.19603616,0.427215189 2.64324151,0.529113924 2.98277201,0.835443038 C3.32230251,1.14177215 3.55415816,1.65126582 3.55415816,2.16075949 C3.55415816,2.67025316 3.32230251,3.17974684 2.98277201,3.48607595 C2.64324151,3.79240506 2.19603616,3.89430379 1.74883081,3.89430379 C1.30162546,3.89430379 0.854420112,3.79240506 0.514889609,3.48607595 C0.175359106,3.17974684 -0.0564965468,2.67025316 -0.0564965468,2.16075949 C-0.0564965468,1.65126582 0.175359106,1.14177215 0.514889609,0.835443038 C0.854420112,0.529113924 1.30162546,0.427215189 1.74883081,0.427215189 Z" id="Shape"></path> </g> </g> </g> </g> </g> </g> </g></svg>';

const rulerIcon =
  '<?xml version="1.0" encoding="UTF-8"?> <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Group"><path id="Path" d="M3.52686 11.97L5.21506 13.659" stroke="#333333" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path id="Path_2" d="M8.59308 6.90369L10.2821 8.59272" stroke="#333333" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path id="Path_3" d="M5.21509 10.2818L6.34139 11.4072" stroke="#333333" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path id="Path_4" d="M6.90405 8.59274L8.03036 9.71821" stroke="#333333" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path id="Path_5" d="M10.2822 5.21472L11.4076 6.34102" stroke="#333333" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path id="Path_6" d="M11.9703 3.52649L13.0966 4.65196" stroke="#333333" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path id="Rectangle" fill-rule="evenodd" clip-rule="evenodd" d="M2.96264 14.7845C2.34105 14.1629 2.34105 13.1551 2.96264 12.5335L12.5335 2.96265C13.1551 2.34107 14.1629 2.34107 14.7845 2.96265L17.0373 5.21548C17.6589 5.83707 17.6589 6.84486 17.0373 7.46644L7.46643 17.0373C6.84484 17.6589 5.83705 17.6589 5.21547 17.0373L2.96264 14.7845Z" stroke="#333333" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></g></svg>';

export const SizeButtonsStyles = css`
  /* Block: Main size buttons component */
  .size-buttons {
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0;
    font-family: inherit;
  }

  /* Modifiers: Component variants */
  .size-buttons--enhanced {
    padding: 0;
  }

  .size-buttons--in-delivery {
    margin: 0;
  }

  /* Element: Content wrapper */
  .size-buttons__content {
    display: flex;
    flex-direction: column;
  }

  /* Element: Header section */
  .size-buttons__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    line-height: 1.2;

    @media (min-width: 1024px) {
      font-size: ${typography.base};
    }
  }

  .size-buttons__header .size-buttons__header-content {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .size-buttons--enhanced .size-buttons__header {
    font-size: 14px;
  }

  /* Element: Title */
  .size-buttons__title {
    font-weight: bold;
    outline: none;
    color: ${colors.black.shade1};

    @media (max-width: 768px) {
      line-height: 15px;
    }
  }

  .size-buttons--enhanced .size-buttons__title {
    @media (max-width: 768px) {
      line-height: 20px;
    }
  }

  /* Element: Fomo badge */
  .size-buttons__fomo {
    display: flex;
    align-items: center;
  }

  .size-buttons__fomo .fomo-badge {
    color: #ea5e73;
    font-size: 12px;
    font-weight: 700;
    line-height: 14px;
  }

  /* Element: Chart data display */
  .size-buttons__chart-data {
    color: #717171;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
  }

  /* Element: Chart button */
  .size-buttons__chart-button {
    display: flex;
    align-items: center;
  }

  .size-buttons__chart-button--enhanced {
    margin-top: 12px;
    justify-content: flex-start;
  }

  /* Size chart link styling */
  :global(.size-buttons__chart-button .sizechart-link) {
    color: ${colors.gray.shade40} !important;
    display: flex !important;
    align-items: center !important;
    line-height: 20px !important;
    cursor: pointer !important;
    padding: 12px 0 !important;
    gap: 4px !important;
    transition: color 0.2s ease !important;
  }

  :global(.size-buttons__chart-button .sizechart-link:hover) {
    color: ${colors.gray.shade50} !important;
  }

  :global(.size-buttons__chart-button .sizechart-link span) {
    position: relative !important;
  }

  :global(.size-buttons__chart-button .sizechart-link span::after) {
    content: '' !important;
    position: absolute !important;
    bottom: -1px !important;
    width: 100% !important;
    height: 1px !important;
    left: 0 !important;
    background-color: ${colors.gray.shade40} !important;
    transition: background-color 0.2s ease !important;
  }

  :global(.size-buttons__chart-button .sizechart-link:hover span::after) {
    background-color: ${colors.gray.shade50} !important;
  }

  /* Icons */
  :global(.size-buttons__chart-button .csicon-scale) {
    color: ${colors.green.shade1};
    margin-right: 10px;
    font-size: ${typography.xl2};
  }

  :global(.size-buttons__chart-button .talla-pie) {
    width: 30px;
    height: 28px;
    background-image: url('${svgToDataUri(shoeIcon)}');
    background-size: contain;
    background-repeat: no-repeat;
    flex-shrink: 0;
  }

  :global(.size-buttons__chart-button .ruler-icon) {
    width: 20px !important;
    height: 20px !important;
    background-image: url('${svgToDataUri(rulerIcon)}') !important;
    background-size: contain !important;
    background-repeat: no-repeat !important;
    flex-shrink: 0 !important;
    display: inline-block !important;
  }

  :global(.size-buttons__chart-button .csicon-arrow_right) {
    color: ${colors.black.shade1};
    font-size: ${typography.xxs};
    margin-left: 5px;
  }

  /* Rebranded theme */
  :global(.size-buttons .size-buttons__chart-button .csicon-scale) {
    color: ${colors.gray.shade45};

    @media (min-width: 768px) {
      font-size: 1.8rem;
    }
  }

  :global(.size-buttons .size-buttons__chart-button .talla-pie) {
    background-image: url('${svgToDataUri(shoeIconRebranded)}');
  }

  /* Element: Size options container */
  .size-buttons__options {
    display: flex;
    position: relative;
    flex-wrap: wrap;
    gap: 8px;
    padding: 4px 0;
  }

  @media (max-width: 768px) {
    .size-buttons__options {
      overflow-x: auto;
      flex-wrap: nowrap;
      gap: 6px;
      padding: 4px 0;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;
      -ms-overflow-style: none;
    }

    .size-buttons__options::-webkit-scrollbar {
      display: none;
    }

    .size-buttons--enhanced .size-buttons__options {
      overflow-x: visible;
      flex-wrap: wrap;
    }
  }

  @media (max-width: 480px) {
    .size-buttons__options {
      gap: 4px;
    }
  }

  /* Responsive adjustments */
  @media (max-width: 768px) {
    .size-buttons {
      margin: 15px 0;
      gap: 12px;
    }
  }

  @media (max-width: 480px) {
    .size-buttons {
      gap: 8px;
    }
  }

  /* Accessibility improvements */
  .size-buttons__chart-button .sizechart-link:focus {
    outline: 2px solid ${colors.blue.shade1};
    outline-offset: 2px;
    border-radius: 4px;
  }

  /* High contrast mode support */
  @media (prefers-contrast: high) {
    .size-buttons__title {
      font-weight: 900;
    }

    .size-buttons__chart-button .sizechart-link {
      border: 1px solid currentColor;
      padding: 8px 12px;
      border-radius: 4px;
    }
  }

  /* Reduced motion support */
  @media (prefers-reduced-motion: reduce) {
    .size-buttons__chart-button .sizechart-link {
      transition: none;
    }

    .size-buttons__chart-button .sizechart-link span::after {
      transition: none;
    }
  }

  /* Touch-friendly interactions */
  @media (hover: none) and (pointer: coarse) {
    .size-buttons__chart-button .sizechart-link {
      min-height: 44px;
      padding: 12px;
    }
  }

  /* Iframe styling for size chart */
  iframe.sizechart-template {
    width: 100%;
    border: none;
    border-radius: 8px;

    @media (min-width: 1024px) {
      display: block;
      min-width: 400px;
      max-width: 680px;
    }
  }
`;
